import { clsx } from "clsx";

interface PasswordStrengthIndicatorProps {
  password: string;
}

function getStrength(password: string): number {
  if (!password) {
    return 0;
  }
  let score = 0;
  if (password.length >= 8) {
    score++;
  }
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) {
    score++;
  }
  if (/\d/.test(password)) {
    score++;
  }
  if (/[^a-zA-Z0-9]/.test(password)) {
    score++;
  }
  return score;
}

const strengthConfig = [
  { label: "", color: "" },
  { label: "Słabe", color: "bg-red-500" },
  { label: "Średnie", color: "bg-amber-500" },
  { label: "Dobre", color: "bg-blue-500" },
  { label: "Silne", color: "bg-green-500" },
] as const;

export function PasswordStrengthIndicator({
  password,
}: PasswordStrengthIndicatorProps) {
  const strength = getStrength(password);

  if (!password) {
    return null;
  }

  const config = strengthConfig[strength] ?? strengthConfig[0];

  return (
    <div className="mt-2">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((level) => (
          <div
            key={level}
            className={clsx(
              "h-1 flex-1 rounded-full transition-colors",
              level <= strength ? config.color : "bg-wash",
            )}
          />
        ))}
      </div>
      <p
        className={clsx(
          "mt-1 text-xs",
          strength <= 1
            ? "text-red-600"
            : strength === 2
              ? "text-amber-600"
              : strength === 3
                ? "text-blue-600"
                : "text-green-600",
        )}
      >
        {config.label}
      </p>
    </div>
  );
}
